<template>
  <div style="background: #fff;overflow: hidden">
    <div class="wrapperBox">
      <div class="bigTitle">完善信息</div>
      <div class="skip" @click="skipVisible = true">跳过 ></div>
    </div>
    <div class="title" style="margin-top: 45px">姓名</div>
    <div class="inputBox flex">
      <input class="flex1" placeholder="请输入真实姓名" v-model="params.name" />
    </div>
    <div class="title">身份证号</div>
    <div class="inputBox flex">
      <input
        class="flex1"
        placeholder="请输入真实身份证号码"
        v-model="params.idCard"
      />
    </div>
    <div class="title">性别</div>
    <div class="flex" style="margin: 20px 30px">
      <div
        class="sex"
        :class="params.sex == 1 ? 'sexActive' : ''"
        @click="params.sex = 1"
      >
        男
      </div>
      <div
        class="sex"
        :class="params.sex == 2 ? 'sexActive' : ''"
        @click="params.sex = 2"
      >
        女
      </div>
    </div>
    <div class="title">渔船编号</div>
    <div class="inputBox flex">
      <input
        class="flex1"
        placeholder="请输入真实渔船号"
        v-model="params.shipCode"
      />
    </div>
    <div class="title">业务员手机号</div>
    <div class="inputBox flex">
      <input
        class="flex1"
        placeholder="推荐业务员手机号"
        v-model="params.shipCode"
      />
    </div>
    <div class="title">渔船证</div>
    <div class="inputBox flex">
      <upload-file
        style="margin: 5px 0;"
        :params="{ path: '/ship' }"
        title="渔船证"
        v-model="params.shipDocument"
      ></upload-file>
    </div>
    <div class="submitButton" @click="submit">完成</div>

    <!--<group>-->
    <!--<x-input required title="真实姓名" v-model="params.name"></x-input>-->
    <!--<x-input required title="身份证" v-model="params.idCard"></x-input>-->
    <!--<x-input title="业务员手机号" v-model="params.traderPhone"></x-input>-->
    <!--<popup-radio-->
    <!--title="性别"-->
    <!--:options="genderOptions"-->
    <!--:value="params.sex"-->
    <!--&gt;</popup-radio>-->
    <!--<x-input title="渔船号" v-model="params.shipCode"></x-input>-->
    <!--</group>-->
    <!--<group>-->
    <!--<upload-file-->
    <!--:params="{ path: '/ship' }"-->
    <!--title="渔船证"-->
    <!--v-model="params.shipDocument"-->
    <!--&gt;</upload-file>-->
    <!--</group>-->
    <!--<div class="button-bottom-wrap" style="display: flex;">-->
    <!--<button-->
    <!--class="button-bottom"-->
    <!--style="background: #454545;flex: 1;"-->
    <!--@click="skipVisible = true"-->
    <!--&gt;-->
    <!--跳过-->
    <!--</button>-->
    <!--<button class="button-bottom" style="flex: 2;" @click="submit">-->
    <!--提交-->
    <!--</button>-->
    <!--</div>-->
    <div v-transfer-dom>
      <confirm
        v-model="skipVisible"
        :close-on-confirm="false"
        title="确认跳过?"
        @on-confirm="handleSkip"
      >
        <p style="text-align:center;">
          相关信息之后可以到我的界面补充！
        </p>
      </confirm>
    </div>
  </div>
</template>

<script>
import { perfectInformation } from "@/api/client";
import UploadFile from "@/components/Upload/UploaderFile";
import { mapActions } from "vuex";
import { validateIdCard } from "@/utils/validate-util";

export const genderOptions = [
  {
    key: "1",
    value: "男"
  },
  {
    key: "2",
    value: "女"
  }
];
export default {
  components: {
    UploadFile
  },
  data() {
    return {
      genderOptions,
      skipVisible: false,
      params: {
        idCard: "",
        sex: "1",
        shipCode: "",
        shipDocument: [],
        name: "",
        traderPhone: ""
      }
    };
  },
  methods: {
    ...mapActions(["fetchUserInfo"]),
    handleSkip() {
      this.skipVisible = false;
      this.$router.push("/");
    },
    submit() {
      let idCard = this.params.idCard || "";
      idCard = idCard.trim();
      if (!validateIdCard(idCard)) {
        this.$showError("身份证格式错误", "warn");
        return;
      }
      this.$vux.loading.show({
        text: "加载中"
      });
      perfectInformation(this.params)
        .then(() => {
          this.$showError("更新成功");
          this.fetchUserInfo();
          setTimeout(() => {
            this.$router.push("/");
          }, 500);
        })
        .catch(e => {
          this.$showError(e);
        })
        .finally(() => {
          this.$vux.loading.hide();
        });
    }
  }
};
</script>

<style scoped>
.wrapperBox {
  padding: 70px 0 0 0;
  margin: 0 62px;
  height: 43px;
  line-height: 43px;
  overflow: hidden;
}
.bigTitle {
  float: left;
  color: #000000;
  font-size: 23px;
}
.skip {
  float: right;
  color: #2386ee;
  font-size: 13px;
  height: 43px;
  line-height: 43px;
  text-decoration: underline;
}
.title {
  color: #1a1a1a;
  font-size: 18px;
  line-height: 44px;
  margin-left: 57px;
  margin-top: 50px;
}
.inputBox {
  margin: 0 57px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.inputBox input {
  color: #999999;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  border: none;
  margin: 13px 0;
}
.submitButton {
  margin: 90px 60px;
  background: #2386ee;
  text-align: center;
  line-height: 92px;
  color: #fff;
  font-size: 18px;
  height: 92px;
  border-radius: 10px;
}
.sex {
  width: 115px;
  height: 45px;
  background: rgba(246, 246, 246, 1);
  border: 1px solid rgba(241, 241, 241, 1);
  border-radius: 6px;
  color: #c6c6c6;
  font-size: 14px;
  text-align: center;
  margin-right: 60px;
}
.sexActive {
  width: 115px;
  height: 45px;
  background: rgba(35, 134, 238, 1);
  border-radius: 6px;
  color: #fff;
}
</style>
